import CityPageTemplate from "../city-template/CityPageTemplate";
import { palmerConfig } from "./data";

export default function PalmerPage() {
  return <CityPageTemplate config={palmerConfig} />;
}